import * as api from '../../api/api-informe-honorarios';
import {
    OBTENER_LLAVES,
    GET_CONFIG_FORMINF_HONO,
    GET_ORIGEN_HONORARIOS,
    GET_RESPONSABLES_SOL,
    GET_SITUACIONES_HONO,
    GET_CRITERIOS_FECHA_HONO,
    GET_INFORMES_HONO,
    POST_GENERAR_HONO

} from '../types';


export const obtenerDatosLlaves = (llaves) => ({
    type:OBTENER_LLAVES,
    payload: llaves
});
export const configuracionFormAction = (query) => ({
    type: GET_CONFIG_FORMINF_HONO,
    payload: api.getConfiguracionForm(query)
});
export const obtenerOrigenHonorario = (query) => ({
    type: GET_ORIGEN_HONORARIOS,
    payload: api.getDetalles(query)
});
export const obtenerSituacionHonorario = (query) => ({
    type: GET_SITUACIONES_HONO,
    payload: api.getDetalles(query)
});
export const obtenerResponsablesSolicitud = (query) => ({
    type: GET_RESPONSABLES_SOL,
    payload: api.getResponsables(query)
});
export const obtenerCriteriosFecha = (query) => ({
    type: GET_CRITERIOS_FECHA_HONO,
    payload: api.getDetalles(query)
});
export const obtenerInformesPrevios = (query) => ({
    type: GET_INFORMES_HONO,
    payload: api.getInformesPrevios(query)
});
export const generarInforme = (data) => ({
    type: POST_GENERAR_HONO,
    payload: api.postGenerarInforme(data)
});